<template>
	<div>
		<el-dialog
			:title="wordTitle"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			width="620px"
			custom-class="manuDialog"
			:before-close="handleClose"
			:destroy-on-close="true"
		>
			<el-input
				type="textarea"
				v-model="textareaVal"
				size="small"
				placeholder="输入要用来拓词的词缀，每行一个"
				:autosize="{ minRows: 3, maxRows: 4 }"
				:style="{
					width: '95%',
				}"
				@change="textareaChange"
			></el-input>
			<!-- <filter-panel :data="groups" @search="filterChange"></filter-panel> -->
			<data-list
				ref="multipleTable"
				:selection="true"
				:loading="loading"
				:columns="columns"
				:data="data"
				:table-style="{ name: 'webclient' }"
				:page="page"
				:rowKey="getRowKeys"
				:reserveSelection="true"
				@page-size-changed="pageSizeChanged"
				@page-changed="pageChanged"
				@sort-change="sortChange"
				@selection-change="selectionChange"
				@valueChanged="valueChanged"
			>
			</data-list>

			<!-- <div class="tips">提示：下次创建厂家词广告组会自动选中已保存的内容</div> -->
			<div class="btn-box">
				<div class="selectNum">已选{{ selectValue.length }}个</div>
				<div>
					<el-button @click="handleClose">取消</el-button>
					<el-button type="primary" @click="onSubmit" :disabled="disabled"
						>保存并生成厂家词广告组</el-button
					>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import adsNewOnlineSer from '@/backend/services/adsNewOnline/adsNewOnlineSer.js';
import api from '@/backend/apiConfig/apiConfig';
import listPageCreate from '@/mixins/listPageCreate';
import select from './select.vue';
const list = listPageCreate({
	searchConfig: {
		api: api.googleAds.searchKeyword,
		method: 'POST',
	},
	getQuery(obj, that) {
		return _.assign(obj, { type: that.type, name: that.name });
	},
});
export default {
	mixins: [list],
	props: {
		dialogVisible: Boolean,
		adGroupId: String,
		wordName: String,
	},
	data() {
		return {
			columns: [
				{
					label: '名称',
					bind: 'name',
				},
				{
					label: '类型',
					bind: 'type',
					type: 'mapping',
					parentEvent(type) {
						var name = '-';
						switch (type) {
							case 1:
								name = '前缀';
								break;
							case 2:
								name = '后缀';
								break;
							case 3:
								name = '前缀+后缀';
								break;
						}
						return name;
					},
					mapType: 'text',
					customize: true,
					columnsType: select,
				},
			],
			groups: {
				others: [
					// {
					// 	label: '类型',
					// 	placeholder: '请选择类型',
					// 	tagName: 'sky-select',
					// 	prop: 'type',
					// 	options: [
					// 		{
					// 			label: '前缀',
					// 			value: 1,
					// 		},
					// 		{
					// 			label: '后缀',
					// 			value: 2,
					// 		},
					// 		{
					// 			label: '前缀+后缀',
					// 			value: 3,
					// 		},
					// 	],
					// 	value: '',
					// },
					{
						label: '名称',
						tagName: 'sky-textarea',
						placeholder: '输入要用来拓词的词缀，每行一个',
						prop: 'name',
						value: '',
						width: '100%',
					},
				],
			},
			selectValue: [],
			page: {
				currentPage: 1,
				totalRecords: 0,
				pageSize: 5,
			},
			name: [],
			type: '',
			textareaVal: '',
			select_number: '', //表格select选中的条数
			select_Id: [], //表格select复选框选中的id
		};
	},
	computed: {
		disabled() {
			return this.selectValue.length == 0;
		},
		wordTitle() {
			return '厂家词-' + this.wordName;
		},
	},
	watch: {
		dialogVisible: {
			handler() {
				this.query();
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		getRowKeys(row) {
			return row.id;
		},
		handleClose() {
			this.textareaVal = '';
			this.name = [];
			this.type = '';
			this.selectValue = [];
			this.page = {
				currentPage: 1,
				totalRecords: 0,
				pageSize: 5,
			};
			this.$refs.multipleTable.clearSelection();
			this.$emit('update:dialogVisible', false);
		},
		selectionChange(column) {
			this.selectValue = column.map(e => {
				return { name: e.name, type: e.type };
			});
			this.select_number = this.selectValue.length;
			this.select_Id = [];
			if (column) {
				column.forEach(row => {
					if (row) {
						this.select_Id.push(row.id);
					}
				});
			}
		},
		async onSubmit() {
			if (this.selectValue.length) {
				let param = {
					adGroupId: this.adGroupId,
					keyWordsTopicRuleDTOS: this.selectValue,
				};
				let res = await adsNewOnlineSer.addManufactureWord(param);
				if (res.data == 'success') {
					this.$message({
						message: '创建厂家词广告组成功',
						type: 'success',
					});
					this.$emit('success');
					this.handleClose();
				}
			}
		},
		textareaChange(value) {
			this.name = value.split('\n').filter(item => {
				return item;
			});
			let param = { name: this.name, type: this.type };
			this.filterChange(param);
		},
		valueChanged(val) {
			this.type = val;
			let param = {
				name: this.name,
				type: this.type,
			};
			this.filterChange(param);
		},
	},
	// mounted() {
	// 	this.query();
	// },
};
</script>

<style lang="scss" scoped>
.manuDialog {
	.tips {
		font-size: 12px;
		font-weight: 400;
		color: #f8494f;
		margin: 10px 0px 20px 0px;
	}
	.selectNum {
		font-size: 14px;
		flex: 1;
		line-height: 35px;
	}
	.btn-box {
		display: flex;
	}
	.filterPanel {
		::v-deep .row {
			padding-left: 0px;
		}
		::v-deep .filterResult {
			padding: 0px;
		}
	}
}
</style>
<style lang="scss">
.manuDialog {
	.el-dialog__body {
		padding: 0px 20px 20px 20px !important;
	}
	.el-pagination {
		padding: 20px 0px;
	}
}
</style>
